import DeleteIcon from "@mui/icons-material/Delete";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton} from "@mui/material";
import {useDeleteAusgangsrechnung} from "../../client/hooks";
import {useMutation, useQueryClient} from "react-query";
import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import {useT} from "../../i18n";

export default function DeleteAusgangsrechnungButton({id}: {id: string}) {
    const mutate = useLoeschenAusgangsrechunug(id);
    const {t} = useT("ausgangsrechnung");
    const popupState = usePopupState({
        variant: "popover",
        popupId: `ertrag-${id}-deactivate`,
    });
    return (
        <>
            <IconButton
                sx={{ position: 'absolute', top: 10, right: 10 }}
                {...bindTrigger(popupState)}
                aria-label="delete"
            >
                <DeleteIcon />
            </IconButton>
            <Dialog {...bindPopover(popupState)}>
                <DialogTitle id="alert-dialog-title">
                    {t("delete-form-title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("delete-form-subtitle")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => popupState.close()} color="inherit">
                        {t("abort")}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            mutate.mutate();
                            popupState.close();
                        }}
                    >
                        {t("delete")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>)

}
function useLoeschenAusgangsrechunug(id:string) {
    const deleteAusgangsrechnung = useDeleteAusgangsrechnung();
    const queryClient = useQueryClient();

    return useMutation(
        () => {
            return deleteAusgangsrechnung(id);
        },
        {
            onSuccess: async () => {
                queryClient.invalidateQueries([
                    "ausgangsrechnungen",id
                ]);
            },
        }
    );
}
